import { useDispatch } from 'react-redux';

import axiosPrivate from 'config/axiosPrivate';

import { transformToSemanticGap } from 'helpers/FormatKeywordsHelper';
import { isValidFormat } from 'helpers/PdfFunction';
import { updateForm } from 'store/Admin/Analyser';

export const useAdminEditText = ({
  t,
  textType,
  combinedKeywords,
  orderContentType,
  setErrorSuccessMsg,
  setIsSuccess,
  setErrorSuccess,
  actualHtmlContent,
  actualTextContent,
  analyseResult,
  keyword,
  metaDescriptionTag,
  list,
  websites,
  stuffedKeywords,
  textTitle,
  titleTag,
  url,
  textId,
  setIsFetchLoading,
}) => {
  const dispatch = useDispatch();

  const editText = async () => {
    const isKeywordsValid =
      textType !== 'TRANSLATED' ? isValidFormat(combinedKeywords) : {};

    if (!isKeywordsValid && orderContentType !== 'GMB') {
      setErrorSuccessMsg(
        ` ${t(
          'Veuillez corriger le format de votre gap sémantique afin de pouvoir sauvegarder le texte en brouillon'
        )}. `
      );
      setIsSuccess(false);
      setErrorSuccess(true);
      return;
    }
    const data = {
      actualHtmlContent,
      actualTextContent,
      analyseResult: analyseResult && JSON.stringify(analyseResult),
      keyword,
      metaDescriptionTag,
      semanticGap: list ? transformToSemanticGap(combinedKeywords) : null,
      internalLinking: websites,
      stuffedKeywords: stuffedKeywords,
      textTitle: textTitle,
      titleTag: titleTag,
      url: url,
    };

    axiosPrivate
      .put(`/texts/${textId}/admin-edit`, data)
      .then((res) => {
        setIsFetchLoading(false);
        dispatch(updateForm(res.data));

        setErrorSuccessMsg(`${t('Le texte a été enregistré avec succès')}!`);
        setIsSuccess(true);
        setErrorSuccess(true);
      })
      .catch(() => {
        setIsFetchLoading(false);

        setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
        setIsSuccess(false);
        setErrorSuccess(true);
      });
  };

  return {
    editText,
  };
};
